import { PageOptions } from './../../../../shared/data-table/data-table.interface';
import { BaseHttpService } from './../../../../shared/base-http/base-http.service';
import { Injectable } from '@angular/core';
import { config } from 'src/config/config';
import { getEnv } from 'src/modules/utility';

@Injectable({
  providedIn: 'root'
})
export class BuildDesignWeightModalService {

  constructor(
    private readonly http: BaseHttpService
  ) { }

  getBuildDesignWeights(page: PageOptions) {
    const url = `${config.tprecmApiBaseUrl[getEnv()]}maint/build-design-weight?page=${page.page}&sort=${page.sort}&order=${page.order}&size=${page.size}`;
    return this.http.get(url);
  }

  addBuildDesignWeight(data: any) {
    const url = `${config.tprecmApiBaseUrl[getEnv()]}maint/build-design-weight`;
    return this.http.post(url, data);
  }

  updateBuildDesignWeight(data: any) {
    const url = `${config.tprecmApiBaseUrl[getEnv()]}maint/build-design-weight`;
    return this.http.put(url, data);
  }

  deleteBuildDesignWeight(id: number) {
    const url = `${config.tprecmApiBaseUrl[getEnv()]}maint/build-design-weight/${id}`;
    return this.http.delete(url);
  }

  getBuildDesignWeightFields(): { field: string, name: string }[] {
    return [
      { field: 'procW', name: 'procW' },
      { field: 'fabW', name: 'fabW' },
      { field: 'ncW', name: 'ncW' },
      { field: 'machW', name: 'machW' },
      { field: 'assyW', name: 'assyW' },
      { field: 'certiW', name: 'certiW' },
      { field: 'finalaW', name: 'finalaW' },
      { field: 'modelW', name: 'modelW' },
      { field: 'layoutW', name: 'layoutW' },
      { field: 'mathW', name: 'mathW' },
      { field: 'checkW', name: 'checkW' },
      { field: 'opsW', name: 'opsW' },
      { field: 'roadM', name: 'roadM' },
      { field: 'roadD', name: 'roadD' },
      { field: 'inputR', name: 'inputR' },
      { field: 'modelCr', name: 'modelCr' },
      { field: 'modelRr', name: 'modelRr' },
      { field: 'dBankRr', name: 'dBankRr' },
      { field: 'dBankR', name: 'dBankR' }
    ];
  }
}
